import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { fetchPoolConfigs } from 'store/thunks/adminPoolConfigsThunk';
import { IPoolConfig } from 'types';
import { ESliceDataFetchingStatus } from 'types/common';

export interface IAdminPoolConfigsState {
  poolConfigs: IPoolConfig[];
  status: ESliceDataFetchingStatus;
  errorMessage: string | null;
  pagesQuantity: number;
  itemsPerPage: number;
  currentPage: number;
}

const initialState: IAdminPoolConfigsState = {
  poolConfigs: [],
  status: ESliceDataFetchingStatus.initial,
  pagesQuantity: 1,
  itemsPerPage: 10,
  currentPage: 0,
  errorMessage: null,
};

export const adminPoolConfigsSlice = createSlice({
  name: 'adminPoolConfigs',
  initialState,
  reducers: {
    poolConfigsListSetPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setItemsPerPoolConfigsListPage: (state, action: PayloadAction<number>) => {
      state.itemsPerPage = action.payload;
      state.currentPage = initialState.currentPage;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(fetchPoolConfigs.fulfilled, (state, { payload }) => {
        state.status = ESliceDataFetchingStatus.success;
        state.poolConfigs = payload.content;
        state.pagesQuantity = payload.details.totalPages;
      })
      .addCase(fetchPoolConfigs.pending, (state) => {
        state.status = ESliceDataFetchingStatus.loading;
        state.errorMessage = null;
      })
      .addCase(fetchPoolConfigs.rejected, (state, action) => {
        state.status = ESliceDataFetchingStatus.error;
        state.errorMessage = action.error.message || 'unknown fetch pool configs list error';
      }),
});

export const selectAdminPoolConfigs = (state: RootState) => state.adminPoolConfigs;

export const { poolConfigsListSetPage, setItemsPerPoolConfigsListPage } =
  adminPoolConfigsSlice.actions;

export const adminPoolConfigsReducer = adminPoolConfigsSlice.reducer;
